<template>
    <header class="header-menu__headroom header-menu__container" :class="{'header-menu__container--no-search': hideSearch}" ref="header">
        <div class="header-menu__inner" :class="{'header-menu__inner--no-search': hideSearch}">
            <a href="/" class="header-menu__logo"><img src="/images/header/stellantis-and-you-logo.svg" alt="Stellantis &You UK" class="header-menu__logo-img" /></a>

            <div class="header-menu__desktop-search-and-menu">
                <ul class="header-menu__links ul__no-bullet header-menu__links--branded">
                    <template v-for="(headerMenu, title) in headerMenus">
                        <li v-if="headerMenu.s" class="header-menu__li" :key="title"><a :href="headerMenu.l" class="header-menu__link">{{ title }}</a></li>
                        <desktop-sub-menu v-else :title="title" :key="'sub' + title" :header-unpinned="headroomUnpinned">
                            <desktop-sub-menu-content :content="headerMenu.d" :is-wide="headerMenu.w" />
                        </desktop-sub-menu>
                    </template>
                </ul>
            </div>

            <div class="header-menu__ctas">
                <a :href="dealerLocatorLink" class="header-menu__cta">
                    <img src="/images/header/find-us.svg" alt="Find us" class="header-menu__cta-logo">
                    Find us
                </a>
                <a href="/contact-us" class="header-menu__cta">
                    <img src="/images/header/call-us.svg" alt="Contact Us" class="header-menu__cta-logo">
                    Contact Us
                </a>
                <a v-if="isLoggedIn" href="/my-account" class="header-menu__cta header-menu__cta--purple">
                    <img src="/images/header/my-account-purple.svg" alt="My account" class="header-menu__cta-logo">
                    {{ adminName }}
                </a>
                <a v-else href="/login" class="header-menu__cta">
                    <img src="/images/header/my-account.svg" alt="My account" class="header-menu__cta-logo" @click="gaTag('My Account', 'Clicked', 'Navigation CTA')">
                    My account
                </a>
            </div>

            <div class="mobile-header-menu__burger-container">
                <input type="checkbox" class="mobile-header-menu__burger-checkbox" id="mobile-header-menu__burger-checkbox" name="mobile-menu" value="1" autocomplete="off" v-model="mobileMenuOpen">
                <div class="mobile-header-menu__bg">
                    <div class="mobile-menu__header">
                        <h3 class="mobile-menu__header-title">Menu</h3>
                        <label for="mobile-header-menu__burger-checkbox" class="mobile-menu__close">
                            <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 13L24.7757 24.7757" stroke="#192A44" stroke-width="1.66667" stroke-linecap="round" />
                                <path d="M24.7757 13L13 24.7757" stroke="#192A44" stroke-width="1.66667" stroke-linecap="round" />
                                <circle cx="19" cy="19" r="18" stroke="#182945" stroke-width="0.833333" />
                            </svg>
                        </label>
                    </div>
                    <div class="mobile-menu__scroll-area" ref="mobileScrollArea">
                        <div class="mobile-menu__search">
                            <form class="header-menu__desktop-search autoconverse__form" @onsubmit="openAutoconverseSearch">
                                <input type="text" v-model="autoconverseSearch" id="header-menu__mobile-search-input" class="header-menu__desktop-search-input" placeholder="Enter your search"  />
                                <img src="/images/search-bar-icon.svg" alt="" class="header-menu__desktop-search-icon" onclick="document.getElementById('header-menu__mobile-search-input').focus();" />
                                <button type="button" @click="openAutoconverseSearch" class="header-menu__desktop-search-button">
                                    <img src="/images/link-icon.svg" alt="Submit" class="header-menu__desktop-search-button-icon" />
                                </button>
                            </form>
                        </div>
                        <template v-for="(headerMenu, title) in headerMenus">
                            <a v-if="headerMenu.s" :href="headerMenu.l" class="mobile-menu__sub-menu-link" :key="title">
                                {{ title }}
                                <img src="/images/header/mobile-menu-arrow.svg" class="mobile-menu__sub-menu-arrow">
                            </a>
                            <mobile-sub-menu v-else :title="title" :key="title" :mobile-menu-open="mobileMenuOpen" :content="headerMenu.d" />
                        </template>
                    </div>
                </div>
                <label for="mobile-header-menu__burger-checkbox">
                    <img src="/images/header/mobile-menu.svg" alt="" class="mobile-header-menu__burger-icon" />
                </label>
            </div>
            <div class="header-menu__desktop-search-container" v-cloak v-show="!hideSearch">
                <form class="header-menu__desktop-search autoconverse__form" @submit="openAutoconverseSearch">
                    <input type="text" v-model="autoconverseSearch" id="header-menu__desktop-search-input" class="header-menu__desktop-search-input" placeholder="Enter your search" />
                    <img src="/images/search-bar-icon.svg" alt="" class="header-menu__desktop-search-icon" onclick="document.getElementById('header-menu__desktop-search-input').focus();" />
                    <button type="button" @click="openAutoconverseSearch" class="header-menu__desktop-search-button">
                        <img src="/images/link-icon.svg" alt="Submit" class="header-menu__desktop-search-button-icon" />
                    </button>
                </form>
            </div>
        </div>
    </header>
</template>

<script>
    import { initHeadroom } from "../../api/InitHeadroom";
    import { mapState, mapGetters } from "vuex";
    import BorderlessLogo from "../Logos/BorderlessLogo.vue";
    import DesktopSubMenu from "./Menus/DesktopSubMenu.vue";
    import DesktopSubMenuContent from './Menus/DesktopSubMenuContent.vue';
    import MobileSubMenu from "./Menus/MobileSubMenu.vue";
    import GetManufacturerFromBrand from '../../api/GetManufacturerFromBrand';
    const bodyScrollLock = require('body-scroll-lock');

    export default {
        components: {
            BorderlessLogo,
            DesktopSubMenu,
            DesktopSubMenuContent,
            MobileSubMenu,
        },
        data() {
            return {
                headroom: null,
                headroomUnpinned: false,
                mobileMenuOpen: false,
                autoconverseSearch: '',
            };
        },
        watch: {
            mobileMenuOpen(newValue, oldValue) {
                if (newValue == true) {
                    bodyScrollLock.disableBodyScroll(this.$refs['mobileScrollArea']);
                    return;
                }
                bodyScrollLock.enableBodyScroll(this.$refs['mobileScrollArea']);
            }
        },
        beforeDestroy() {
            bodyScrollLock.enableBodyScroll(this.$refs['mobileScrollArea']);
            if (this.headroom) {
                this.headroom.destroy();
            }
        },
        methods: {
            headerUnpinned() {
                this.headroomUnpinned = true;
            },
            headerPinned() {
                this.headroomUnpinned = false;
            },
            openAutoconverseSearch(event) {
                event.preventDefault();
                console.log(this.autoconverseSearch);
                autoSearch.showSearch(event, '784b3fba-bcd6-42cd-b185-29302fb90a72', this.autoconverseSearch);
                return false;
            }
        },
        computed: {
            ...mapState("Layout", {
                isLoggedIn: "admin",
                adminName: "adminName",
            }),
            ...mapGetters({
                brand: "Layout/brand",
                compareCount: "Layout/compareCount",
                compareLink: "Layout/compareLink",
                headerMenuLinks: "Layout/headerMenuLinks",
            }),
            dealerLocatorLink() {
                if (this.haveBrand) {
                    return '/dealer-locator?brand=' + encodeURIComponent(this.brand);
                }
                return '/dealer-locator';
            },
            manufacturerName() {
                return GetManufacturerFromBrand(this.brand);
            },
            haveBrand() {
                return (this.brand != '' && this.brand != "randd") ? true : false;
            },
            headerMenus() {
                return this.headerMenuLinks[this.brand] ?? {};
            },
            hideSearch() {
                if (typeof window.hideSearch !== 'undefined' && window.hideSearch == true) {
                    return true;
                }

                return false;
            },
        },
        mounted() {
            if (!this.$refs.header) {
                return;
            }
            this.headroom = initHeadroom(this.$refs.header, this.headerUnpinned, this.headerPinned);
        },
    };
</script>



// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/Layout/RobinsAndDayHeader.vue